import { CardGrid, CardGridItem } from 'src/components/cardGrid';
import { NoResultAlert } from 'src/components/noResultAlert';
import { SubHeaderWithSorting } from 'src/components/subHeader';

import { ProductCard } from '../productCard';
import { formatProductGridData } from './ProductGrid.helper';
import { ProductGridProps } from './ProductGrid.interface';
import { ProductCardGrid } from './ProductGrid.styled';

export const ProductGrid = (props: ProductGridProps) => {
  return (
    <>
      <SubHeaderWithSorting
        title="Products"
        selectedSortOption={props.selectedSortOption}
        onSortChange={props.onSortChangeHandle}
        numResults={props.numResults}
        totalCount={props.totalCount}
      />
      <NoResultAlert
        isLoading={props.isLoadingInfiniteProducts}
        dataToCheck={
          props.infiniteProductsData?.pages?.flatMap((page) => page.products) ??
          []
        }
      />
      <ProductCardGrid ref={props.scrollRef}>
        <CardGrid
          isLoading={props.isLoadingInfiniteProducts}
          error={props.errorLoadingInfiniteProducts}
          updatePage={props.getNextProductPage}>
          {formatProductGridData(props.infiniteProductsData).map((product) => (
            <CardGridItem item key={product.product_code}>
              <ProductCard product={product} />
            </CardGridItem>
          ))}
        </CardGrid>
      </ProductCardGrid>
    </>
  );
};
